import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router"
import { LoginService } from 'src/app/service/login.service';
import { ChatListComponent } from './chat-list/chat-list.component';
import { ChatsService } from 'src/app/service/chats.service';
import { MessagesService } from 'src/app/service/messages.service';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { Chats } from 'src/app/interfaces/chatData';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
  providers: [MessageService]
})
export class ChatComponent implements OnInit {
  rightSideBar: boolean = false;
  sh: boolean = true;
  dev: boolean = false;
  schat: boolean = false;
  term: string = ''
  value3: string = "";
  @ViewChild(ChatListComponent)
  private chatListComponent!: ChatListComponent;
  searchResultData: any[] = [];
  @Output() searchTermChange: EventEmitter<string> = new EventEmitter();
  placeholderText: string = 'Press enter to search';
  searchInputFocused: boolean = false;
  rolUsuario: any;
  idStatus!: number
  private subscription!: Subscription
  currentPage = 0;
  loading = false;
  @ViewChild('chatsContainer') chatsContainer!: ElementRef;
  idSuscription: any;
  pageNumberBusqueda: number = 1;
  pageSizeBusqueda: number = 20;
  
  constructor(private router: Router,
    private loginservie: LoginService, private chatsService: ChatsService,
    private messageService: MessagesService, private messagesAlerta: MessageService,
    private route: ActivatedRoute, private translate: TranslateService) {
      this.rolUsuario = loginservie.chatCrmUser.idRol
      messageService.dispositivo$().subscribe(data => {
          this.idSuscription = data == null ? null:data.id;
          this.currentPage = 0
          this.totalPages = undefined
          this.noMoreChats = false
      });
      messageService.searchTerm$.subscribe(term =>{
        this.term = term;
        if(term == undefined || term == null || term == ""){
          this.search = false;
        }
      })
      // Establecer idiomas disponibles y el idioma por defecto
      translate.addLangs(['en', 'es']);
      translate.setDefaultLang('es');
  }

  ngOnInit(): void {
    this.messageService.updateSearchTerm('')
    this.messageService.obtenerStatus().subscribe(value=>{
      this.idStatus = value;
      this.currentPage = 0
      this.totalPages = undefined
    });
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }

  totalPagesWithSearch!: number
  async searchChats() {
    if(this.idSuscription == null){
      return;
    }
    if(this.term !== '' ){
      if(this.loginservie.chatCrmUser.idRol === 3){
        const data = await this.chatsService.searchChats(this.term, this.idSuscription,
           this.pageNumberBusqueda, this.pageSizeBusqueda, this.loginservie.chatCrmUser.id);
           this.chatsActualesConBusqueda = data.data.content
           console.log('hizo la peticion con iduser')
        this.messageService.setChats(this.chatsActualesConBusqueda);
        if(this.chatsActualesConBusqueda.length == 0){
          this.messagesAlerta.add({ severity: 'info', summary: this.translate.instant('CHAT_NO_MESSAGES_SUMMARY'), 
          detail: this.translate.instant('CHAT_NO_MESSAGES') });
        }
        console.log(this.chatsActualesConBusqueda)
        console.log('term chat component', this.term)
        // this.totalPagesWithSearch = data.data.totalPages
        this.messageService.updateSearchTerm(this.term);
      }      
      else{
        const data = await this.chatsService.searchChats(this.term, this.idSuscription, 
          this.pageNumberBusqueda, this.pageSizeBusqueda);
          console.log('hizo la peticion sin iduser')
          this.chatsActualesConBusqueda = data.data.content
        this.messageService.setChats(this.chatsActualesConBusqueda);
         if(this.chatsActualesConBusqueda.length == 0){
          this.messagesAlerta.add({ severity: 'info', summary: this.translate.instant('CHAT_NO_MESSAGES_SUMMARY'), 
          detail: this.translate.instant('CHAT_NO_MESSAGES') });
        }
        console.log(this.chatsActualesConBusqueda)
        // this.totalPagesWithSearch = data.data.totalPages
        
        this.messageService.updateSearchTerm(this.term);
      }

    }else{
      this.messageService.updateSearchTerm(this.term);
      if (this.rolUsuario === 1 || this.rolUsuario === 2) {
        const response = await this.messageService.getConversations(this.idSuscription, 0);
        this.messageService.setChats(response.data.result)
      } else {
        const idUser = this.loginservie.chatCrmUser.id;
        const response = await this.messageService.getConversations(this.idSuscription, 0, idUser);
        this.messageService.setChats(response.data.result)
      }
    }

  }


  changeSh(): void {
    this.schat = true
  }
  backSh(): void {
    this.schat = false
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (window.innerWidth > 960) {
      this.schat = false
    };
  }

onSearchInputFocus() {
  this.placeholderText = this.translate.instant('CHAT_ENTER_TO_SEARCH');
  this.searchInputFocused = true;
  
}

onSearchInputBlur() {
  this.searchInputFocused = false;
  if (!this.term) {
    this.placeholderText = this.translate.instant('CHAT_SEARCH_CHAT');
  }
}

onSearchInputChange(event: Event) {
  const inputValue = (event.target as HTMLInputElement).value;
  if (inputValue && this.searchInputFocused) {
    this.placeholderText = '';
  } else {
    this.placeholderText = this.translate.instant('CHAT_SEARCH_CHAT');
  }
}


  redirectHome(): void {
    this.router.navigate(['/dashboard'])
  }
  redirectaccount(): void {
    this.router.navigate(['/account'])
  }
  redirectDevice(): void {
    this.router.navigate(['/devices'])
  }
  settingsModal: boolean = false;
  settingModal(): void {
    this.settingsModal = true
  }
  rebootModal: boolean = false;
  rebootsModal(): void {
    this.rebootModal = !this.rebootModal
  }
  editModal: boolean = false;
  editssModal(): void {
    this.editModal = !this.editModal
  }
  newChatModal: boolean = false
// En el componente principal donde se utiliza el diálogo
newChatsModal(): void {
  if (this.idSuscription != null) {
    // Toggle la visibilidad del modal
    this.newChatModal = !this.newChatModal;
  } else {
    this.messagesAlerta.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('CHAT_ERROR_SELECT_DEVICE') });
  }
}

  mostrarMensaje(mensaje: any){
    this.messagesAlerta.add(mensaje);
  }
  
  openCon(): void {
    this.sh = !this.sh
  }
  rightSB(): void {
    this.rightSideBar = true
  }
  showDevice(): void {
    this.dev = !this.dev
  }
  search: boolean = false
  async openSearch(): Promise<void> {
    if(this.idSuscription != null){
      this.search = !this.search
      if(!this.search){
        this.term = ''; 
        this.messageService.updateSearchTerm(this.term);
        if (this.rolUsuario === 1 || this.rolUsuario === 2) {
          const response = await this.messageService.getConversations(this.idSuscription, 0);
          this.messageService.setChats(response.data.result)
        } else {
          const idUser = this.loginservie.chatCrmUser.id;
          const response = await this.messageService.getConversations(this.idSuscription, 0, idUser);
          this.messageService.setChats(response.data.result)
        }
      }
      this.term = '';
        this.messageService.obtenerChats().subscribe(chatList=>{
          this.chatsActuales = chatList
        })
        this.messageService.setChats(this.chatsActuales)
    }else{
      this.messagesAlerta.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('CHAT_ERROR_SELECT_DEVICE') });
    }

  }


  async onScroll() {
    const container = this.chatsContainer.nativeElement;
    if (this.term === '') {
      //const element = event.target;
      
      // Si el scroll está cerca del fondo y no está en proceso de carga
      if (container.scrollHeight - container.scrollTop <= container.clientHeight + 100 && !this.loading && !this.term) {
        this.loading = true;
        // Incrementar la página actual

        this.currentPage++;
        // Realizar la llamada para obtener más chats
        if (this.currentPage >= this.totalPages) {
          this.noMoreChats = true
          this.currentPage = this.totalPages - 1
        } else {
          await this.loadMoreChats();
        }
        this.loading = false;
        this.loadingMessages = false
      }
    }else{
      if (container.scrollHeight - container.scrollTop <= container.clientHeight + 100 && !this.loading && this.term) {
        this.loading = true;
        
        

        this.pageNumberBusqueda++;
        if (this.pageNumberBusqueda >= this.totalPagesWithSearch) {
          this.pageNumberBusqueda = this.totalPagesWithSearch - 1
        } else {
          if(this.loginservie.chatCrmUser.idRol === 3){
            this.loadingMessages = true
            const data = await this.chatsService.searchChats(this.term, this.idSuscription,
               this.pageNumberBusqueda, this.pageSizeBusqueda, this.loginservie.chatCrmUser.id);
               if (Array.isArray(data.data.content) && data.data.content.length > 0){
                this.chatsActualesConBusqueda = this.chatsActualesConBusqueda.concat(data.data.content);
                this.messageService.setChats(this.chatsActualesConBusqueda)
               }
            this.totalPagesWithSearch = data.data.totalPages
            this.messageService.updateSearchTerm(this.term);
          }      
          else{
            this.loadingMessages = true
            const data = await this.chatsService.searchChats(this.term, this.idSuscription, 
              this.pageNumberBusqueda, this.pageSizeBusqueda);
              if (Array.isArray(data.data.content) && data.data.content.length > 0){
                this.chatsActualesConBusqueda = this.chatsActualesConBusqueda.concat(data.data.content);
                this.messageService.setChats(this.chatsActualesConBusqueda)
               }
            this.totalPagesWithSearch = data.data.totalPages
            this.messageService.updateSearchTerm(this.term);
          }

        }
        this.loading = false;
        this.loadingMessages = false
      }
    }
  
  }

  loadingMessages: boolean = false
  noMoreChats: boolean = false
  chatsActuales!: Chats[]
  chatsActualesConBusqueda!: Chats[]
  totalPages!: any;
  async loadMoreChats() {
    if(!this.noMoreChats){
      this.loadingMessages = true
      let response
      let idStatusToLoad
      if(this.idStatus !== 0){
        idStatusToLoad = this.idStatus
      }else{
        idStatusToLoad = 0
      }

      if (this.rolUsuario === 1 || this.rolUsuario === 2) {
         response= await this.messageService.getConversations(this.idSuscription, idStatusToLoad ,undefined, this.currentPage);
      } else {
        const idUser = this.loginservie.chatCrmUser.id;
         response = await this.messageService.getConversations(this.idSuscription, idStatusToLoad, idUser, this.currentPage);
      }
      this.messageService.obtenerChats().subscribe(chats=>{
        this.chatsActuales = chats
      })
      if (Array.isArray(response.data.result) && response.data.result.length > 0) {
        this.totalPages = response.data.totalPages
        this.chatsActuales = this.chatsActuales.concat(response.data.result);
        this.messageService.setChats(this.chatsActuales)
      } else {
        this.noMoreChats = true;
      }
    }
   
  }
}
